import React from 'react';
import { PropTypes } from 'prop-types';

import SelectFancy from '@atoms/SelectFancy';

const getYearOptions = startYear => {
    let year = new Date().getFullYear();
    const options = [];
    // newest to oldest
    while (year >= startYear) {
        options.push({ label: year, value: `${year}` });
        year -= 1;
    }
    return options;
};

const SelectYear = ({
    hideLabel,
    id,
    isDisabled,
    placeholder = '-- Select a Year --',
    name,
    label = 'Choose a Year',
}) => {
    const options = getYearOptions(1921);

    return (
        <SelectFancy
            isDisabled={isDisabled}
            hideLabel={hideLabel}
            id={id}
            label={label}
            name={name}
            options={options}
            placeholder={placeholder}
        />
    );
};

SelectYear.propTypes = {
    isDisabled: PropTypes.bool,
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
};

export default SelectYear;
